<div class="common-text-input__container"
  [id]="fieldTypeList.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--focused': fieldTypeList.showList,
      'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null"
    #containerFieldList>
    <div class="common-text-input__container-box-inner-list">
      <div class="common-text-input__block-header">
        <div class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label">{{fieldTypeList.titleField}}</span>
          @if(field.required){
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if (field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
            @if (field.relatedInfo?.length){
              <button class="common-button__icon-sm-noborder"
                  pTooltip="{{'common.related-info'| afTranslate}}"
                  tooltipPosition="top"
                  (click)="openModalRelatedInfo(field.relatedInfo)">
                  <i class="lf-icon-search-text common-icon__md"></i>
              </button>
            }
            @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
              <tooltip-in-report [inReport]="fieldTypeList.inReport"></tooltip-in-report>
            }
          </div>
        </div>
        <div class="common-text-input__buttons-right-header">
          <div class="common-text-input__buttons-right-header-container">
            <button class="common-button__icon-sm-noborder"
              [disabled]="field.noEditable"
              (click)="toggleFilter($event)">
              <i class="common-icon__md"
                [ngClass]="fieldTypeList.showList?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
            </button>
            @if (!field.noEditable) {
              <p-overlayPanel #fieldTypeListSimpleOverlay
                styleClass="common-dropdown-list__overlay-field-list"
                (onShow)="fieldTypeList.showList = true"
                (onHide)="closeList()">
                <ng-template pTemplate="content">
                  <div class="common-dropdown-list__overlay-field-list-container"
                    [ngStyle]="{'width': containerFieldListElement.nativeElement?.offsetWidth+'px'}">
                    @if (fieldTypeList.addNew){
                      <div class="common-dropdown-list__add-items-container">
                        <div class="common-dropdown-list__add-items-container-inner">
                          <label class="common-text-input__block-field-input"
                            [ngClass]="{'common-text-input__block-field-input--with-value': fieldTypeList.newValue,
                              'common-text-input__block-field-input--error': fieldTypeList.errorNewValue }"
                            [for]="'input-new-'+fieldTypeList.id">
                            <input class="common-text-input__input"
                              type="text"
                              autocomplete="off"
                              [id]="'input-new-'+fieldTypeList.id"
                              [name]="'input-new-'+fieldTypeList.id"
                              [(ngModel)]="fieldTypeList.newValue"
                              (keydown.enter)="insertNewValue()"
                              [placeholder]="'common.create-element' | afTranslate"/>
                            @if(fieldTypeList.newValue){
                              <button class="common-text-input__icon-clean-input"
                                (click)="fieldTypeList.newValue = ''">
                                <i class="lf-icon-close-thick common-icon__sm"></i>
                              </button>
                            }
                          </label>
                          <div class="common-button__body-icon-set-sm">
                            <button class="common-button__icon-md-noborder"
                              (click)="insertNewValue()">
                              <i class="lf-icon-check common-icon__md"></i>
                            </button>
                            <button class="common-button__icon-md-noborder"
                              (click)="resetListValue()">
                              <i class="lf-icon-close common-icon__md"></i>
                            </button>
                          </div>
                        </div>
                        @if (fieldTypeList.errorNewValue){
                          <div class="common-text-input__mandatory-tag">
                            <span [afTranslate]="'common.required-3-characters'">_Es necesario introducir al menos 3 caracteres</span>
                          </div>
                        }
                      </div>
                    }@else {
                      <div class="common-dropdown-list__overlay-header-search-container">
                        <div class="common-search__container-tonal">
                          <div class="common-search__container-input-text">
                            <input type="search"
                              class="common-search__input-text"
                              [id]="'search-input-'+fieldTypeList.id"
                              [(ngModel)]="fieldTypeList.findDropdown"
                              placeholder="{{'common.search-item' | afTranslate}}"
                              (keyup)="changeList()">
                          </div>
                          <div class="common-search__block-button-search">
                            @if(fieldTypeList.findDropdown){
                              <button class="common-button__icon-xs-noborder"
                                (click)="resetSearch()">
                                <i class="lf-icon-close-thick common-icon__sm"></i>
                              </button>
                            }
                            <div class="h-[22px]"
                                ngClass="{{fieldTypeList.findDropdown?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
                            <i class="lf-icon-search common-icon__md"
                                ngClass="{{!fieldTypeList.findDropdown?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
                          </div>
                        </div>
                        @if(field.isOpen && !fieldTypeList.public && !isLanding && !field.noEditable){
                          <button class="common-button__icon-md-border"
                            pTooltip="{{'templates-concept.new-template' | afTranslate}}"
                            tooltipPosition="top"
                            [tooltipDisabled]="field.type !== 'customTemplate'"
                            (click)="createNewValue()">
                            <i class="lf-icon-sum common-icon__md"></i>
                          </button>
                        }
                      </div>
                    }
                    <div class="common-dropdown-list__overlay-list-container">
                      @if (fieldTypeList.deleteError){
                        <div class="common-status-message__s-container-alert">
                          <span-tooltip class="common-status-message__s-title"
                            [text]="'field-type-list.message-info' | afTranslate"></span-tooltip>
                          <button class="common-button__icon-xs-noborder"
                              (click)="aceptNotDelete()">
                              <i class="lf-icon-close-thick common-icon__sm"></i>
                          </button>
                        </div>
                      }
                      @for (listValue of fieldTypeList.filterList | byWord:fieldTypeList.findDropdown:[fieldToFind] | afOrderBy:fieldTypeList.orderList:fieldTypeList.orderAsc; track $index) {
                        @if (checkListValue(listValue.type)) {
                          <div [ngClass]="{'common-dropdown-list__cascade-item-with-cursor': field.isTree && listValue.children?.length,
                            'common-dropdown-list__user-item': !(field.isTree && listValue.children?.length)}"
                            [attr.disabled]="listValue.disabled || field.noEditable?true:null">
                            <div [ngClass]="{'common-dropdown-list__container-icon-arrow': field.isTree && !field.uniqueLastSelect && !listValue.children?.length }">
                              @if (field.isTree && listValue.children?.length){
                                <button class="common-button__icon-sm-noborder"
                                    (click)="showChildren(listValue)">
                                    <i class="common-icon__md"
                                      [ngClass]="listValue.show?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
                                </button>
                              }
                            </div>
                            <div class="common-dropdown-list__item-container">
                              @if(!field.uniqueLastSelect || !listValue.children?.length) {
                                <div class="common-button__block-button-md-checkbox">
                                  <button class="common-button__icon-md-checkbox"
                                    [ngClass]="{'common-button__icon-md-checkbox--selected': listValue.selected,
                                    'common-button__icon-md-checkbox--disabled': listValue.disabled || field.noEditable}"
                                    [disabled]="listValue.disabled || field.noEditable"
                                    (click)="selectItem(listValue, 'selectValue')">
                                    <i class="common-icon__md"
                                      ngClass="{{listValue.selected?'lf-icon-radio-button-active':'lf-icon-step-first'}}"></i>
                                  </button>
                                </div>
                              }
                              <div class="common-dropdown-list__user-item-wrapper"
                                (click)="selectItem(listValue)">
                                <span-tooltip class="common-dropdown__list-text-title"
                                  [ngClass]="{'common-dropdown__list-text-title--disabled': listValue.disabled || field.noEditable}"
                                  [text]="listValue.text"
                                  [isDeleted]="listValue.isDeleted"></span-tooltip>
                                @if(listValue.isUserValue){
                                  <i class="lf-icon-configuration common-icon__md common-icon__neutral"></i>
                                }
                              </div>
                              @if(listValue.isUserValue){
                                <div class="common-dropdown-list__user-item-options">
                                  <button class="common-button__icon-set-xs"
                                      pTooltip="{{'common.edit' | afTranslate}}"
                                      tooltipPosition="top"
                                      (click)="editListValueElement(listValue)">
                                      <i class="lf-icon-editable-form common-icon__md"></i>
                                  </button>
                                  <button class="common-button__icon-set-xs"
                                      pTooltip="{{'common.remove' | afTranslate}}"
                                      tooltipPosition="top"
                                      (click)="deleteListValue(listValue)">
                                      <i class="lf-icon-trash common-icon__md"></i>
                                  </button>
                                </div>
                              }
                            </div>
                          </div>
                          @if (listValue.children && listValue.children.length && listValue.show) {
                            <tree-list-children class="common-dropdown-list__tree-container"
                              [field]="field"
                              [findDropdown]="fieldTypeList.findDropdown"
                              [fieldToFind]="fieldToFind"
                              [filterList]="listValue.children"
                              (treeChildrenEmit)="treeSimpleOn($event)">
                            </tree-list-children>
                          }
                        }
                      }@empty {
                        @if(field.type === 'customTemplate'){
                          <div class="common-empty-state__message-list"
                            [afTranslate]="'field-type-list.empty-associated-templates'">_Este concepto no tiene plantillas asociadas</div>
                        }
                      }
                    </div>
                  </div>
                </ng-template>
              </p-overlayPanel>
            }
          </div>
        </div>
      </div>
      <div class="common-list__list-group min-h-[22px]">
        <!-- @if (field.multiple){
          @for (listElement of fieldTypeList.listElementSelect; track $index){
            <div class="common-chips__standard"
                [attr.disabled]="field.noEditable?true:null">
                <span-tooltip class="common-chips__label-text"
                  [text]="listElement.text"></span-tooltip>
                @if (!field.noEditable){
                  <button class="lf-icon-close-round common-icon__sm common-chips__icon-close"
                    (click)="addOrDeleteSelectedValue($event, listElement)"></button>
                }
            </div>
          }
        }@else { -->
          <div class="common-text-input__block-selected-item"
            [ngClass]="{'common-text-input__block-selected-item--with-value': fieldTypeList.selectItemName && !field.noEditable}">
            <span-tooltip class="common-text-input__selected-option"
              [attr.disabled]="field.noEditable?true:null"
              [text]="fieldTypeList.selectItemName"></span-tooltip>
            @if (fieldTypeList.selectItemName && !field.noEditable) {
              <button class="common-text-input__icon-clean-input"
                (click)="resetItem()">
                <i class="lf-icon-close-thick common-icon__sm"></i>
              </button>
            }
          </div>
        <!-- } -->
      </div>
    </div>
    @if(field.uniqueLastSelect && field.multiline && fieldTypeList.listTreeLastSelect?.length){
      <div class="field-type-list__container-tree-selected">
        @for (itemSelected of fieldTypeList.listTreeLastSelect; track itemSelected) {
          <div class="field-type-list__container-tree-selected-inner"
            [ngStyle]="{'padding-left': 26+(8*$index)+'px'}"
            [ngClass]="{'field-type-list__container-tree-selected-inner--selected': $last}">
            <div class="field-type-list__text-tree-selected">
              @if ($last){
                <div class="common-badge__block-dot-md">
                  <div class="common-badge__dot-xs-main-1000"></div>
                </div>
              }
              <span-tooltip [text]="itemSelected.text"></span-tooltip>
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
    </div>
  }
</div>
